import { graphql } from "msw";
import { MOCK_HEADER_DATA } from "@header/mocks/data";
export var headerHandlers = [graphql.query("HeaderConfiguration", function (_request, response, ctx) {
  return response(ctx.data({
    configuration: {
      header: MOCK_HEADER_DATA
    }
  }));
})];